import { KeyValue } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FlowSoftwareLicense } from '../../../admin/pages/flows/shared.models';
import { EmployeeDetails } from "../../components/employees/shared.moldels";
import { BadgeRole, EmployeeLicense, KeyValueApp, KeyValueSet, License, Nation, PersonInfo, Province, SmartworkingAgreement, Software, SoftwareBrand, Companies, EmployeeAvatarPhoto } from "./global.models";

@Injectable()
export class GlobalService
{
	// constructor
	constructor
		(
			private http: HttpClient,
			@Inject('BASE_URL') private baseUrl: string
		)
	{ }

	// get all nations
	getAllNations(): Observable<Nation[]>
	{
		return this.http.get<Nation[]>(`${this.baseUrl}api/shared/global/nations`);
	}

	// get all provinces
	getAllProvinces(): Observable<Province[]>
	{
		return this.http.get<Province[]>(`${this.baseUrl}api/shared/global/provinces`);
	}

	// get all badge roles
	getAllBadgeRoles(): Observable<BadgeRole[]>
	{
		return this.http.get<BadgeRole[]>(`${this.baseUrl}api/shared/global/badgeRoles`);
	}

	// get all smartworking agreements
	getAllSmartworkingAgreements(): Observable<SmartworkingAgreement[]>
	{
		return this.http.get<SmartworkingAgreement[]>(`${this.baseUrl}api/shared/global/smartworkingAgreements`);
	}

	// get person basic info
	personInfo(id: string): Observable<PersonInfo>
	{
		return this.http.get<PersonInfo>(`${this.baseUrl}api/shared/global/person/${id ?? null}`);
	}

	//get All Companies
	getAllCompanies(excludeParentCompany: boolean): Observable<Companies[]>
	{
		return this.http.get<Companies[]>(`${this.baseUrl}api/shared/global/companies/${excludeParentCompany}`);
	}

	// get all job application schoolings
	getAllJobApplicationSchoolings(): Observable<KeyValue<number, string>[]>
	{
		return this.http.get<KeyValue<number, string>[]>(`${this.baseUrl}api/shared/global/jobApplicationSchoolings`);
	}

	// get all job application professional areas
	getAllJobApplicationProfessionalArea(): Observable<KeyValue<number, string>[]>
	{
		return this.http.get<KeyValue<number, string>[]>(`${this.baseUrl}api/shared/global/jobApplicationProfessionalArea`);
	}

	// get all job application qualifications
	getAllJobApplicationQualifications(): Observable<KeyValue<number, string>[]>
	{
		return this.http.get<KeyValue<number, string>[]>(`${this.baseUrl}api/shared/global/jobApplicationQualifications`);
	}

	// get all provinces
	getAllEmployeeCategoriesConsultant(): Observable<KeyValueSet[]>
	{
		return this.http.get<KeyValueSet[]>(`${this.baseUrl}api/shared/global/employeeCategoriesConsultant`);
	}

	// get all consultant contract edited
	getAllConsultantContractEdited(): Observable<KeyValueSet[]>
	{
		return this.http.get<KeyValueSet[]>(`${this.baseUrl}api/shared/global/consultantContractEdited`);
	}

	// check user is in role
	isUserInRole(roleAlias: string): Observable<boolean>
	{
		return this.http.get<boolean>(`${this.baseUrl}api/shared/global/isUserInRole?roleAlias=${roleAlias}`)
	}

	// get all employee details
	getEmployeeDetails(id: string): Observable<EmployeeDetails>
	{
		return this.http.get<EmployeeDetails>(`${this.baseUrl}api/shared/global/employeeDetails/${id}`);
	}

	// get all employee authorizations
	getEmployeeAuthorizations(id: string): Observable<KeyValueApp[]> {
		return this.http.get<KeyValueApp[]>(`${this.baseUrl}api/shared/global/employeeAuthorizations/${id}`);
	}

	// get all software brands
	getAllSoftwareBrands(): Observable<SoftwareBrand[]>
	{
		return this.http.get<SoftwareBrand[]>(`${this.baseUrl}api/shared/global/softwareBrands`);
	}

	// get all software
	getAllSoftware(brandId?: number): Observable<Software[]>
	{
		return this.http.get<Software[]>(`${this.baseUrl}api/shared/global/software/${brandId}`);
	}

	// get software by alias
	getSoftwareByAlias(alias: string): Observable<FlowSoftwareLicense> {
		return this.http.get<FlowSoftwareLicense>(`${this.baseUrl}api/shared/global/software/getSoftwareByAlias/${alias}`);
	}

	// get licenses by software
	getAllLicenses(softwareId?: string): Observable<License[]>
	{
		return this.http.get<License[]>(`${this.baseUrl}api/shared/global/licences/${softwareId}`);
	}

	// get employee licenses
	getEmployeeLicenses(employeeId: string): Observable<EmployeeLicense[]> {
		return this.http.get<EmployeeLicense[]>(`${this.baseUrl}api/shared/global/employeeLicenses/${employeeId}`);
	}

	// get all mandatory software
	getPcMandatorySoftware(id: string): Observable<FlowSoftwareLicense[]> {
		return this.http.get<FlowSoftwareLicense[]>(`${this.baseUrl}api/shared/global/getRequirementsMandatorySoftware/${id ?? null}`);
	}

	// get all employees
	getAllEmployees(): Observable<KeyValueApp[]>
	{
		return this.http.get<KeyValueApp[]>(`${this.baseUrl}api/shared/global/allEmployees`);
	}

	// get all company locations
	getAllCompanyLocations(): Observable<KeyValueApp[]>
	{
		return this.http.get<KeyValueApp[]>(`${this.baseUrl}api/shared/global/allCompanyLocations`);
	}

	// get all company offices
	getAllCompanyOffices(locationId: string): Observable<KeyValueApp[]>
	{
		return this.http.get<KeyValueApp[]>(`${this.baseUrl}api/shared/global/allCompanyOffices/${locationId ?? null}`);
	}

	// get employee photo
	getEmployeePhoto(employeeId: string): Observable<EmployeeAvatarPhoto> {
		return this.http.get<EmployeeAvatarPhoto>(`${this.baseUrl}api/shared/shared/GetEmployeePhoto/${employeeId}`);
	}
}